import { Component , ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { NavController, NavParams, Slides, LoadingController, Platform } from 'ionic-angular';
import { ApiService } from '../../app/services/api.service';
import { Broadcaster } from '../../app/broadcaster';
import { Localization } from '../../app/app.localization';
import { Storage } from '@ionic/storage';
import { AlertController } from 'ionic-angular';

@Component({
    selector: 'page-loading',
    templateUrl: 'loading.html',
    providers: [ApiService]
})

export class LoadingPage {

    messages: Array<string>;

    /**
     *
     * @param navCtrl
     * @param navParams
     * @param _productService
     */
    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        private _loc: Localization,
        private _apiService: ApiService,
        private storage: Storage,
        private broadcaster: Broadcaster,
        private alertCtrl: AlertController,
        private loadingCtrl: LoadingController,
        public platform: Platform,
        private rd:Renderer2
    ) {

        console.log("subscribe loading page");
        this.messages = [];
        this.broadcaster.on<string>('loading.debug')
            .subscribe(state => {
                console.log(state);
                this.messages.push(state);
            });

    }

}



// WEBPACK FOOTER //
// ./src/pages/loading/loading.ts